"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PresenterKnockItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PresenterKnockItem = require("./PresenterKnockItem.styled");
var _KnockItemFooter = _interopRequireDefault(require("../KnockItemFooter/KnockItemFooter"));
var _KnockItemHeader = _interopRequireDefault(require("../KnockItemHeader/KnockItemHeader"));
var _excluded = ["type", "name"];
var PresenterKnockItem = exports.PresenterKnockItem = function PresenterKnockItem(_ref) {
  var type = _ref.type,
    name = _ref.name,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_PresenterKnockItem.PresenterKnockItemContainer, {
    key: props._id
  }, /*#__PURE__*/_react["default"].createElement(_KnockItemHeader["default"], {
    type: type,
    presenterName: name
  }), /*#__PURE__*/_react["default"].createElement(_KnockItemFooter["default"], (0, _extends2["default"])({
    type: type,
    presenterName: name
  }, props)));
};
PresenterKnockItem.propTypes = {
  _id: _propTypes["default"].string.isRequired,
  type: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  sources: _propTypes["default"].array,
  onApprove: _propTypes["default"].func.isRequired,
  isCameraOn: _propTypes["default"].bool,
  isMicrophoneOn: _propTypes["default"].bool,
  onDeny: _propTypes["default"].func.isRequired,
  onAVClicked: _propTypes["default"].func,
  onAssignKnockToSource: _propTypes["default"].func
};